(function(){
  // 等待 DOM 完全加载后执行
  document.addEventListener('DOMContentLoaded', function() {
    initCommunityCarousels();
  });

  function initCommunityCarousels() {
    // 获取所有轮播组件
    const carousels = document.querySelectorAll('[id^="community-hero-carousel-"]');
    
    carousels.forEach(function(carousel) {
      initCarousel(carousel);
    });
  }

  function initCarousel(root) {
    if (!root) return;

    const track = root.querySelector('.community-carousel__track');
    const slides = Array.from(track.querySelectorAll('.community-slide'));
    const leftBtn = root.querySelector('.community-arrow--left');
    const rightBtn = root.querySelector('.community-arrow--right');
    const tabs = Array.from(root.querySelectorAll('.community-tab'));
    const dotsWrap = root.querySelector('.community-carousel__dots');

    let current = 0;
    const slideCount = slides.length;

    // 创建 dots
    function createDots(){
      dotsWrap.innerHTML = '';
      for (let i=0;i<slideCount;i++){
        const btn = document.createElement('button');
        btn.className = 'community-dot' + (i===0 ? ' is-active' : '');
        btn.dataset.index = i;
        btn.addEventListener('click', () => goTo(i));
        dotsWrap.appendChild(btn);
      }
    }

    function updateDots(){
      const dots = Array.from(dotsWrap.children);
      dots.forEach((d, i) => d.classList.toggle('is-active', i===current));
    }

    function updateTabs(){
      tabs.forEach((t, i) => {
        const active = (i === current);
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    function goTo(index){
      // 限制索引范围，不循环
      if (index < 0) index = 0;
      if (index >= slideCount) index = slideCount - 1;
      current = index;
      
      // 检查是否是移动端
      const isMobile = window.innerWidth <= 900;
      
      if (!isMobile) {
        const gap = parseFloat(getComputedStyle(track).gap) || 20;
        const slideWidth = slides[0].getBoundingClientRect().width;
        const viewportWidth = root.querySelector('.community-carousel__viewport').getBoundingClientRect().width;
        
        // 最后一张：右对齐，左侧露出上一张
        if (current === slideCount - 1) {
          // 计算让最后一张右对齐的位置：viewport宽度 - 卡片宽度
          const translateX = -(slideWidth + gap) * (slideCount - 1) + (viewportWidth - slideWidth);
          track.style.transform = `translateX(${translateX}px)`;
        } else {
          // 正常左对齐，右侧露出下一张
          const translateX = -(slideWidth + gap) * current;
          track.style.transform = `translateX(${translateX}px)`;
        }
      } else {
        // 移动端：平滑滚动到对应卡片
        const targetSlide = slides[current];
        if (targetSlide) {
          targetSlide.scrollIntoView({ 
            behavior: 'smooth', 
            block: 'nearest',
            inline: 'start'
          });
        }
      }
      
      updateDots();
      updateTabs();
      updateArrows();
    }
    
    function updateArrows(){
      // 第一张时隐藏左箭头
      if (current === 0) {
        leftBtn.disabled = true;
        leftBtn.classList.add('is-hidden');
      } else {
        leftBtn.disabled = false;
        leftBtn.classList.remove('is-hidden');
      }
      
      // 最后一张时隐藏右箭头
      if (current === slideCount - 1) {
        rightBtn.disabled = true;
        rightBtn.classList.add('is-hidden');
      } else {
        rightBtn.disabled = false;
        rightBtn.classList.remove('is-hidden');
      }
    }

    // 事件监听器
    leftBtn.addEventListener('click', () => goTo(current - 1));
    rightBtn.addEventListener('click', () => goTo(current + 1));

    // tab 点击与 slide 对应
    tabs.forEach((t, i) => {
      t.addEventListener('click', () => goTo(i));
    });

    // 支持键盘左右键
    root.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') goTo(current - 1);
      if (e.key === 'ArrowRight') goTo(current + 1);
    });

    // 处理视频播放交互
    slides.forEach((slide, idx) => {
      const videoWrapper = slide.querySelector('.community-slide__video-wrapper');
      const video = slide.querySelector('.community-slide__video');
      const iframe = slide.querySelector('.community-slide__iframe');
      
      // 为视频添加播放/暂停控制
      if (video) {
        slide.addEventListener('click', (e) => {
          e.stopPropagation();
          if (video.paused) {
            video.play();
          } else {
            video.pause();
          }
        });
      }
      
      // 为 YouTube/Instagram iframe 添加交互提示
      if (iframe) {
        slide.addEventListener('click', (e) => {
          e.stopPropagation();
          // YouTube iframe 点击会自动处理播放
        });
      }
      
      // 非视频区域点击跳转到下一张
      if (!videoWrapper && !video) {
        slide.addEventListener('click', (e) => {
          goTo(idx + 1);
        });
      }
    });

    // 调整窗口尺寸时确保位置正确
    window.addEventListener('resize', () => goTo(current));

    // 初始化
    createDots();
    updateTabs();
    updateArrows();
  }
})();
